import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

export default class HelpService extends BaseService {
  getDataChainHelp = ({ ...data }) => {
    return this.axios.get(API_ENDPOINTS.HELP_HELP_CHAIN_INFO, {
      params: { ...data },
    });
  };

  getDataStoresHelp = ({ ...data }) => {
    return this.axios.get(API_ENDPOINTS.GET_HELP_STORE_INFO, {
      params: { ...data },
    });
  };

  getManualFileDetail = () => {
    return this.axios.get(API_ENDPOINTS.HELP_MANUAL_FILE_DETAIL);
  };

  getManualFile = ({...data}) => {
    return this.axios.get(API_ENDPOINTS.HELP_MANUAL_FILE, {
      params: { ...data },
    });
  };

  removeManual = ({ helpId }) => {
    return this.axios.get(
        API_ENDPOINTS.HELP_REMOVE_MANUAL_FILE
            .replace("{helpId}", helpId)
    );
  };

  saveManual = ({ ...data }) => {
    return this.axios.post(API_ENDPOINTS.HELP_SAVE_MANUAL, {...data});
  };

  createDataRankingAggregateHelp = ({ ...data }) => {
    return this.axios.get(API_ENDPOINTS.HELP_AGGREGATE_RANKING_HOTEL, {
      params: { ...data },
    });
  };

  getFileRankingReport = () => {
    return this.axios.get(API_ENDPOINTS.HELP_GET_RANKING_FILE_REPORT);
  };

  createCronRankingReport = (data) => {
    return this.axios.post(API_ENDPOINTS.CREATE_CRON_RANKING_FILE_REPORT, data);
  };

  getCronRankingReport = (data) => {
    return this.axios.post(API_ENDPOINTS.GET_CRON_RANKING_FILE_REPORT, data);
  };

  getFileRankingCronReport = () => {
    return this.axios.get(API_ENDPOINTS.HELP_GET_CRON_RANKING_FILE_REPORT);
  };

}
